import React from 'react'
import CustomButton from './customButton'
import LinkIcon from '../../../icons/linkIcon'
interface Props {
  href: string
  children: React.ReactNode
  sx: React.CSSProperties
}
const LinkButton = ({ href, children, sx }: Props) => {
  return (
    <CustomButton sx={sx} href={href} endIcon={<LinkIcon />}>
      {children}
    </CustomButton>
  )
}

export default LinkButton
